import { useEffect } from 'react'

import { useAuth } from '../../../../hooks/use-auth'
import { useUserQuery } from '../../../../hooks/use-user-query'
import { tokenUtils } from '../../../../utils/token-utils'
import { useCarrierOnboarding } from '../_context/carrier-onboarding-context'

/**
 * Custom hook to handle automatic step completion based on user state
 */
export const useStepCompletion = () => {
  const { markStepAsCompleted } = useCarrierOnboarding()
  const { selectedWorkspace } = useAuth()
  const { myDetails } = useUserQuery()
  const hasUsername = Boolean(myDetails?.username)
  const isAuthenticated = tokenUtils.isAuthenticated()

  useEffect(() => {
    // Mark login step as completed if user is authenticated and has username
    if (isAuthenticated && hasUsername) {
      markStepAsCompleted('login')
    }
  }, [isAuthenticated, hasUsername, markStepAsCompleted])

  useEffect(() => {
    // Mark MC/DOT verification step as completed if workspace is verified
    if (selectedWorkspace?.workspace.isVerified) {
      markStepAsCompleted('mc_dot')
    }
  }, [selectedWorkspace?.workspace.isVerified, markStepAsCompleted])
}
